import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSync } from '../sync/useSync';
import { fmtTime } from '../lib/format';

interface SuccessState {
  reading: {
    equipmentName: string;
    location: string;
    operatorName: string;
    effectiveReadingAt: string;
    abnormalStatus: 'normal' | 'warning' | 'critical';
    source: 'online' | 'offline';
  };
  nextRecommendedAt: string | null;
  queued: boolean;
  /** queued while online — it uploads in the background within seconds */
  syncing?: boolean;
}

export default function Success() {
  const nav = useNavigate();
  const { pending } = useSync();
  const state = useLocation().state as SuccessState | null;
  if (!state) return <Navigate to="/" replace />;
  const { reading, nextRecommendedAt, queued } = state;
  // "syncing" = queued online; once the background push drains the outbox, treat it as done
  const syncing = !!state.syncing && pending > 0;
  const offline = queued && !state.syncing;
  const tone = offline ? 'warn' : reading.abnormalStatus === 'critical' ? 'bad' : reading.abnormalStatus === 'warning' ? 'warn' : 'ok';

  return (
    <div className="app">
      <div className="hero">
        <div className={`hero-band ${tone}`} />
        <div className="hero-body center pad">
          <div style={{ fontSize: 56 }}>{offline ? '💾' : '✓'}</div>
          <h1 style={{ marginTop: 6 }}>{offline ? 'Saved on this phone' : 'Reading saved'}</h1>
          <p className="muted" style={{ margin: 0 }}>{reading.equipmentName}</p>
        </div>
      </div>

      <div className="card">
        <div className="row"><span className="k">Submitted</span><span className="v">{fmtTime(reading.effectiveReadingAt)}</span></div>
        <div className="row"><span className="k">Operator</span><span className="v">{reading.operatorName}</span></div>
        {nextRecommendedAt && <div className="row"><span className="k">Next reading</span><span className="v">{fmtTime(nextRecommendedAt)}</span></div>}
        <div className="row">
          <span className="k">Status</span>
          <span className={`chip ${tone === 'ok' ? 'ok' : tone === 'bad' ? 'bad' : 'warn'}`}>
            {offline ? '⏳ Waiting for sync' : syncing ? '↑ Uploading…' : reading.abnormalStatus === 'normal' ? '✓ Synced' : `Synced · ${reading.abnormalStatus}`}
          </span>
        </div>
      </div>

      {offline && (
        <p className="center muted">
          Stored safely on the phone — it uploads automatically when there's a connection. Keep working.
        </p>
      )}

      <button onClick={() => nav('/', { replace: true })}>Done</button>
    </div>
  );
}
